import { useSessionStore } from '@hooks/states/useSessionStore';
import { localesThatUseIPForPrices } from '@libs/constants';
import { getPriceCountry } from '@libs/get-price-country.helper';
import { useRouter } from 'next/router';
import { useMemo } from 'react';

export const usePriceCountry = () => {
  const router = useRouter();

  const locale = useMemo(() => router.locale, [router.locale]);

  const sessionPriceCountry = useSessionStore(state => state.session?.priceCountry);

  return useMemo(() => {
    const localePriceCountry = getPriceCountry(locale);

    // if we get a session and the session on .eu domains is not equal to the locale, we use the session
    if (localesThatUseIPForPrices.includes(locale)) {
      return sessionPriceCountry?.toUpperCase() ?? localePriceCountry;
    }
    return localePriceCountry;
  }, [locale, sessionPriceCountry]);
};
